export default __webpack_public_path__ + "static/media/seo.1306bdaa.png";